interface BrandingCache {
    logoUrl: string | null;
    isEnabled: boolean;
    timestamp: number;
}

export const getBrandingCache = (companyId: string | undefined): string | null => {
    if (!companyId) return null;
    const branding = localStorage.getItem(`branding-${companyId}`);
    if (!branding) return null;

    const brandingCache = JSON.parse(branding) as BrandingCache;
    return brandingCache.logoUrl;
};

export const getBrandingCacheTimestamp = (companyId: string | undefined): number | undefined => {
    if (!companyId) return undefined;
    const branding = localStorage.getItem(`branding-${companyId}`);
    if (!branding) return undefined;

    const brandingCache = JSON.parse(branding) as BrandingCache;
    return brandingCache.timestamp;
};

export const setBrandingCache = (companyId: string | undefined, logoUrl: string | null, isEnabled: boolean) => {
    if (!companyId) return;
    const key = `branding-${companyId}`;
    const cacheData: BrandingCache = {
        logoUrl,
        isEnabled,
        timestamp: Date.now(),
    };
    localStorage.setItem(key, JSON.stringify(cacheData));
};

export const removeBrandingCache = (companyId?: string) => {
    if (!companyId) return;
    localStorage.removeItem(`branding-${companyId}`);
};
